import { render, staticRenderFns } from "./NewModule.vue?vue&type=template&id=747cbd30&scoped=true"
import script from "./NewModule.vue?vue&type=script&lang=js"
export * from "./NewModule.vue?vue&type=script&lang=js"
import style0 from "./NewModule.vue?vue&type=style&index=0&id=747cbd30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747cbd30",
  null
  
)

export default component.exports